import Swal from "sweetalert2/src/sweetalert2.js";

export function ErrorPopup(text: string) {
  if (text === "-") {
    return;
  }
  return Swal.fire({
    html: text,
    icon: "error",
    buttonsStyling: false,
    confirmButtonText: "Tamam",
    customClass: {
      confirmButton: "btn btn-primary",
    },
  });
}

export function SuccessPopup(text: string) {
  return Swal.fire({
    html: text,
    icon: "success",
    buttonsStyling: false,
    confirmButtonText: "Tamam",
    customClass: {
      confirmButton: "btn btn-primary",
    },
  });
}
export function SuccessConfirmPopup(html: string, confimText: string, cancelText: string) {
  return Swal.fire({
    title: "<div class='fw-bold text-success'>Başarılı</div>",
    html: html,
    icon: "success",
    showCancelButton: true,
    confirmButtonColor: "#47BE7D",
    // cancelButtonColor: "#cc3636",
    confirmButtonText: confimText,
    cancelButtonText: cancelText,
  });
}

export function WarningPopup(html: string, confimText: string, cancelText: string) {
  return Swal.fire({
    title: "<div class='fw-bold text-danger'>Dikkat</div>",
    html: html,
    icon: "warning",
    showCancelButton: true,
    // confirmButtonColor: "#3085d6",
    // cancelButtonColor: "#cc3636",
    confirmButtonText: confimText,
    cancelButtonText: cancelText,
  });
}

export async function ConfirmPopup(text: string, confimText: string, cancelText: string) {
  const result = await Swal.fire({
    title: text,
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonText: confimText,
    cancelButtonText: cancelText,
  });
  return result.isConfirmed;
}
export async function SuccessAlert(text: string) {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  await Toast.fire({
    icon: "success",
    title: text,
  });
}
export async function InfoAlert(text: string) {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  await Toast.fire({
    icon: "info",
    title: text,
  });
}
